import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import testLibrary from '../components/test/testLibrary.vue'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

const routes = [
  {
    path: '/policies',
    name: 'policies',
    component: () => import('../components/policies.vue')
  },
  {
    path: '/login',
    name: 'home',
    component: () => import('../components/LoginComponent.vue')
  },
  {
    path: '/simpleAuth',
    name: 'simpleAuth',
    component: () => import('../components/SimpleAuth.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../components/admin/admin.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('../components/admin/dashboard.vue')
      },
      {
        path: 'adminLogin',
        name: 'adminLogin',
        component: () => import('../components/admin/adminLoginForm.vue')
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/',
    name: 'main',
    component: () => import('../components/MainMenuList'),
    meta: { requiresAuth: true }
  },
  {
    path: '/myInfo',
    name: 'myInfo',
    component: () => import('../components/mainMenue/MyInfo'),
    meta: { requiresAuth: true }
  },
  {
    path: '/noticeList',
    name: 'noticeList',
    component: () => import('../components/notice/NoticeList'),
    meta: { requiresAuth: true },
    props: { boardType: 'noticeList' }
  },

  {
    path: '/readNotice',
    name: 'readNotice',
    component: () => import('../components/notice/ReadNotice'),
    meta: { requiresAuth: true },
    props: true
  },

  {
    path: '/writeNotice',
    name: 'writeNotice',
    component: () => import('../components/notice/WriteNotice'),
    meta: { requiresAuth: true, authWrite: true },
    props: { boardType: 'noticeList', editType: 1 }
  },

  {
    path: '/updateNotice',
    name: 'updateNotice',
    component: () => import('../components/notice/WriteNotice'),
    meta: { requiresAuth: true, authWrite: true },
    props: { boardType: 'noticeList', editType: 2 }
  },
  {
    path: '/bulletinList',
    name: 'bulletinList',
    component: () => import('../components/notice/NoticeList'),
    meta: { requiresAuth: true },
    props: { boardType: 'bulletinList' }
  },

  {
    path: '/readBulletin',
    name: 'readBulletin',
    component: () => import('../components/notice/ReadNotice'),
    meta: { requiresAuth: true },
    props: true
  },

  {
    path: '/writeBulletin',
    name: 'writeBulletin',
    component: () => import('../components/notice/WriteNotice'),
    meta: { requiresAuth: true, authWrite: true },
    props: { boardType: 'bulletinList', editType: 1 }
  },

  {
    path: '/updateBulletin',
    name: 'updateBulletin',
    component: () => import('../components/notice/WriteNotice'),
    meta: { requiresAuth: true, authWrite: true },
    props: { boardType: 'bulletinList', editType: 2 }
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    component: () => import('../components/UserView'),
    meta: { requiresAuth: true }
  },
  {
    path: '/pushList',
    name: 'pushList',
    component: () => import('../components/push/PushList'),
    meta: { requiresAuth: true }
  },
  {
    path: '/specimenPushList',
    name: 'specimenPushList',
    component: () => import('../components/push/specimenPushList'),
    meta: { requiresAuth: true }
  },
  {
    path: '/specimenPushListConfig',
    name: 'specimenPushListConfig',
    component: () => import('../components/push/specimenPushListConfig'),
    meta: { requiresAuth: true }
  },
  {
    path: '/testLibrary',
    name: 'testLibrary',
    // component: () => import(/* webpackChunkName: "testLibrary", webpackPrefetch: true */ '../components/test/testLibrary'),
    component: () => import('../components/test/testLibrary'),
    // component: testLibrary,
    meta: { requiresAuth: true }
  },
  {
    path: '/testLibraryInfo',
    name: 'testLibraryInfo',
    component: () => import('../components/test/testLibraryInfo'),
    meta: { requiresAuth: true }
  },
  {
    path: '/testResult',
    name: 'testResult',
    component: () => import('../components/test/testResult'),
    meta: { requiresAuth: true }
  },
  {
    path: '/clientInfo',
    name: 'clientInfo',
    component: () => import('../components/client/ClientInformation'),
    meta: { requiresAuth: true }
  },
  {
    path: '/invoice',
    name: 'invoice',
    component: () => import('../components/client/Invoice'),
    meta: { requiresAuth: true }
  },
  {
    path: '/createClient',
    name: 'createClient',
    component: () => import('../components/client/CreateClient'),
    meta: { requiresAuth: true }
  },
  {
    path: '/modifyClient',
    name: 'modifyClient',
    component: () => import('../components/client/ModifyClient'),
    meta: { requiresAuth: true }
  },
  {
    path: '/salesReport',
    name: 'salesReport',
    component: () => import('../components/client/SalesReport'),
    meta: { requiresAuth: true }
  },
  // {
  //   path: '/salesReportTest',
  //   name: 'salesReportTest',
  //   component: () => import('../components/client/SalesReportTest'),
  //   meta: { requiresAuth: true }
  // },
  {
    path: '/invoiceBankingTransaction',
    name: 'invoiceBankingTransaction',
    component: () => import('../components/client/InvoiceBankingTransaction'),
    meta: { requiresAuth: true }
  },
  // {
  //   path: '/invoiceBankingTransactionTest',
  //   name: 'invoiceBankingTransactionTest',
  //   component: () => import('../components/client/InvoiceBankingTransactionTest'),
  //   meta: { requiresAuth: true }
  // },
  {
    path: '/registerTestIssueReminder',
    name: 'registerTestIssueReminder',
    component: () => import('../components/test/registerTestIssueReminder'),
    meta: { requiresAuth: true }
  },
  {
    path: '/testIssueReminder',
    name: 'testIssueReminder',
    component: () => import('../components/test/testIssueReminder'),
    meta: { requiresAuth: true }
  },
  {
    path: '/testIssueReminderDetail',
    name: 'testIssueReminderDetail',
    component: () => import('../components/test/testIssueReminderDetail'),
    meta: { requiresAuth: true }
  },
  {
    path: '/testIssueReminderPushSetting',
    name: 'testIssueReminderPushSetting',
    component: () => import('../components/test/testIssueReminderPushSetting'),
    meta: { requiresAuth: true }
  },
  {
    path: '/testRequest',
    name: 'testRequest',
    component: () => import('../components/test/testRequest'),
    meta: { requiresAuth: true }
  },
  {
    path: '/testRequestDetail',
    name: 'testRequestDetail',
    component: () => import('../components/test/testRequestDetail'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registerTestRequest',
    name: 'registerTestRequest',
    component: () => import('../components/test/registerTestRequest'),
    meta: { requiresAuth: true }
  },
  {
    path: '/testIncongruity',
    name: 'testIncongruity',
    component: () => import('../components/test/testIncongruity'),
    meta: { requiresAuth: true }
  },
  {
    path: '/testIncongruityDetail',
    name: 'testIncongruityDetail',
    component: () => import('../components/test/testIncongruityDetail'),
    meta: { requiresAuth: true }
  },
  {
    path: '/InvoiceBankStatement',
    name: 'InvoiceBankStatement',
    component: () => import('../components/client/InvoiceBankStatement'),
    meta: { requiresAuth: true }
  },
  {
    path: '/voc',
    name: 'voc',
    component: () => import('../components/utility/voc/voc'),
    meta: { requiresAuth: true }
  },
  {
    path: '/vocDetail',
    name: 'vocDetail',
    component: () => import('../components/utility/voc/vocDetail'),
    meta: { requiresAuth: true }
  },
  {
    path: '/pinResetAuth',
    name: 'pinResetAuth',
    component: () => import('../components/auth/pinResetAuthentication'),
    meta: { requiresAuth: true }
  }

]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  mode: 'history'
})
router.beforeEach(function (to, from, next) {
  const userInfo = store.getters['userStore/getUserInfo']
  const UserID = userInfo.UserID

  if (to.matched.some(function (routeInfo) { // 로그인정보가 필요한 경우
    return routeInfo.meta.authWrite
  })) {
    if (UserID == '') {
      return next('/login')
    } else {
      if (!userInfo.AuthNoticeWrite ) {
        alert('접근 권한이 없습니다.');
        return next('/');
      }
      return next();
    }
  }
  if (to.matched.some(function (routeInfo) { // 로그인정보가 필요한 경우
    return routeInfo.meta.requiresAuth
  })) {
    if (UserID === '') { // 로그인 정보가 없는 경우 로그인 페이지로 이동
      if (to.path !== '/login') { // 현재 페이지가 로그인 화면이 아닌 경우에만 이동
        // next('/login') // 로그인 페이지로 이동
        next({
          path: '/login',
          query: { redirect: to.path } // ✅ 원래 가려던 주소 (쿼리 포함)
        })
      } else {
        next() // 이미 로그인 페이지인 경우 그대로 진행
      }
    } else { // 로그인 정보가 있다면 이동하려던 페이지로 이동
      Vue.$gtag.set({
        user_id: UserID
      })

      Vue.$gtag.event('page_change', {
        event_category: 'Page',
        event_label: UserID,
        value: to.path
      })
      next({ replace: true })
    }
  } else { // 로그인 정보가 필요없다면 로그인 없이 페이지 이동
    if ((from.path === '/login' && to.path === '/login')) { // 현재 페이지가 로그인 화면인 경우
      next(false)
    } else {
      next() // 페이지 이동
    }
  }
})

export default router
